import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="admin-card" style={{ textAlign: 'center', padding: '60px', marginTop: '40px' }}>
                    <div style={{ fontSize: '48px', color: '#ef4444', marginBottom: '20px' }}>
                        <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <h2 style={{ color: '#1e293b' }}>Something went wrong</h2>
                    <p style={{ color: '#64748b', maxWidth: '500px', margin: '0 auto 24px auto' }}>
                        We encountered an unexpected error while rendering this page. Please try refreshing or contact support if the problem persists.
                    </p>
                    <div style={{ fontSize: '12px', color: '#94a3b8', background: '#f8fafc', padding: '12px', borderRadius: '8px', marginBottom: '24px', fontFamily: 'monospace' }}>
                        {this.state.error?.toString()}
                    </div>
                    <button
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Dashboard
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
